export default __webpack_public_path__ + "static/infinity-a22981fc29f5fc73bc6c95cc1fa39b81.png";